import apiClient from '../client';

const STOCK_RETURN_BASE = `/digitization/v1/stock-return`;
const WAREHOUSE_BASE = `/traceability/v1/center/get_warehouse_list`;
const SUPPLIER_BASE = `/digitization/v1/supplier/list`;
const CUSTOMER_BASE = `/digitization/v1/customer/list`;
const PRODUCT_REPORT_BASE = `/digitization/v1/product/report`;

export const stockReturnApi = {
  getNextReturnCode: () => apiClient.get(`${STOCK_RETURN_BASE}/next-code`),
  getProductLots: prodId =>
    apiClient.get(`${STOCK_RETURN_BASE}/product-lots/${prodId}`),
  createStockReturn: data => apiClient.post(STOCK_RETURN_BASE, data),
  updateStockReturn: (id, data) =>
    apiClient.put(`${STOCK_RETURN_BASE}/${id}`, data),
  getStockReturn: id => apiClient.get(`${STOCK_RETURN_BASE}/${id}`),
  deleteStockReturn: id => apiClient.delete(`${STOCK_RETURN_BASE}/${id}`),
  getStockReturnReport: params =>
    apiClient.post(`${STOCK_RETURN_BASE}/report`, params),
  getWarehouses: () => apiClient.get(WAREHOUSE_BASE),
  getSuppliers: () => apiClient.get(SUPPLIER_BASE),
  getCustomers: () => apiClient.get(CUSTOMER_BASE),
  getProductReport: params => apiClient.post(PRODUCT_REPORT_BASE, params)
};

export default stockReturnApi;
